import { Component, OnInit } from '@angular/core';
import { PackageReceiveService } from '../../data-services/package.receive.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { PackageDataService } from '../../data-services/package.service';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { PackageReceiveProgressComponent } from './package.receive.progress';
import { CardModule } from 'primeng/card';

@Component({
   selector: 'package-receive-review',
   templateUrl: './package.receive.review.html',
   styleUrls: ['./step.css'],
   providers: [MessageService],
   imports: [Toast, CommonModule, PackageReceiveProgressComponent, CardModule]
})
export class PackageReceiveReviewComponent implements OnInit {

   package: PackageReceiveService;
   showSpinner: boolean = false;
   orderType: any;
   saveSuccessful: boolean = false;
   noClient: boolean = false;

   constructor(private packageDataService: PackageDataService,
      private packageReceiveSvc: PackageReceiveService,
      private messageService: MessageService,
      private router: Router) {
      this.package = packageReceiveSvc;
      this.package.stepnumber = 6;
   }

   ngOnInit() {
      if (!this.package.trackingNumber) {
         this.router.navigate(['package-receive-new/package-receive-scan']);
      }

      if (this.package.client) {
         this.orderType = this.package.client.ProcessingType;
      }

      this.savePackage();
   }

   goAgain() {
      this.router.navigate(['package-receive-new/package-receive-scan']);
   }

   goToSender() {
      this.router.navigate(['package-receive-new/package-receive-sender']);
   }

   saveMessage: string = "";
   public savePackage() {
      if (!this.package.ShipmentType) {
         this.saveMessage = "Cannot save due to missing shipment type!";
         return;
      }
      if (!this.package.client) {
         this.noClient = true;
         this.saveMessage = "Cannot save due to missing client!";
      }

      this.package.Id = 0;
      if (this.package.client) {
         this.package.ClientId = this.package.client.Id;
      }

      this.packageDataService.savePackage(this.package.model()).subscribe(() => {
         this.messageService.add({ severity: 'success', summary: 'Package', detail: `Tracking ID [${this.package.trackingNumber}] saved`, life: 4000 });
         this.saveSuccessful = true;
      });
   }
}
